// startup
// Load entry module and return exports
__webpack_modules__["./src/components/cookiebar/cookiebar.js"](0, {}, __webpack_require__);
__webpack_modules__["./src/components/cookiebar/_cookiebar.scss"](0, {}, __webpack_require__);
// This entry module doesn't tell about it's top-level declarations so it can't be inlined
var __webpack_exports__ = {};
__webpack_modules__["?6190"](0, __webpack_exports__, __webpack_require__);
